// A failed fetch as the query client's retry and sign-out policy reads it (QueryProvider): the status, the server's
// error message, and Retry-After in ms.
export class FetchError extends Error {
  constructor(message: string, readonly status: number, readonly retryAfterMs?: number) {
    super(message);
    this.name = 'FetchError';
  }
}

export async function fetchError(response: Response): Promise<FetchError> {
  const body = (await response.json().catch(() => ({}))) as { error?: unknown };
  const message = typeof body.error === 'string' && body.error ? body.error : `HTTP ${response.status}`;
  const header = response.headers.get('Retry-After')?.trim();
  const retryAfter = header ? Number(header) : NaN;
  return new FetchError(message, response.status, Number.isFinite(retryAfter) ? retryAfter * 1000 : undefined);
}
